<template>
  <div>
    <router-link
      v-if="data.pumpId"
      :to="
        $route.query.branchId
          ? {
              path: `/Retail-Outlet/pump/transactions/${data.pumpId}`,
              query: {
                date: data.date,
                index: data.index,
                branchId: data.branchId,
                pumpId: data.pumpId,
                companyId: $route.query.companyId,
                regionId: this.$route.query.regionId,
                dealerId: this.$route.query.dealerId,
                groupId: this.$route.query.groupId,
                startDate: this.$route.query.startDate,
                endDate: this.$route.query.endDate,
              },
            }
          : {
              path: `/Retail-Outlet/pump/transactions/${data.pumpId}`,
              query: {
                date: data.date,
                index: data.index,
                pumpId: data.pumpId,
                companyId: $route.query.companyId,
                regionId: this.$route.query.regionId,
                dealerId: this.$route.query.dealerId,
                groupId: this.$route.query.groupId,
                startDate: this.$route.query.startDate,
                endDate: this.$route.query.endDate,
              },
            }
      "
      class="mr-2 btn details_btn"
      >{{ data.viewTransactionsButton }}</router-link
    >

    <button
      class="btn details_btn"
      :style="{ cursor: loadingDeny ? 'not-allowed' : '' }"
      :disabled="loadingDeny"
      @click="rejectData($event)"
      v-if="data.manualOpeningReading > 0 || data.manualLastReading > 0"
    >
      <span v-if="!loadingDeny">{{ $t("text.clickButtons.reject") }}</span>

      <pulse-loader size="7px" v-if="loadingDeny"></pulse-loader>
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
      loadingDeny: false,
    };
  },

  components: {
    PulseLoader,
  },

  methods: {
    rejectData() {
      const data = {
        id: this.data.id,
        pumpId: this.data.mode == "pump" ? this.data.pumpId : null,
        tankId: this.data.mode == "tank" ? this.data.tankId : null,
      };
      this.loadingDeny = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/branch/RejectData/${this.data.branchId}`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: "Data rejected successfully",
            type: "success",
            duration: 10000,
          });
          this.loadingDeny = false;
        })
        .catch((error) => {
          this.loadingDeny = false;
        });
    },
  },
};
</script>
